import {appliedConfig, introBackgroundConfig} from "../../config/commonConfig";

import Footer from "../Common/Footer";
import { Tooltip } from "../Common/Tooltip";
import React, {useEffect, useState} from "react";
import WOW from "wowjs";
import CourcesHeader from "../themes/fullScreen/CourcesHeader";
import About from "../Cources/About";
import Author from "../Cources/Author";
import Program from "../Cources/Program";
import Benefits from "../Cources/Benefits";
import CallToAction from "../Common/CallToAction";
import Schedule from "../Cources/Schedule";
// import Contact from "../Cources/Contact";
import Payment from "../Cources/Payment";


const Courses = () => {
    
    const appliedIntro = appliedConfig.appliedIntro;

    const handleNavClick = (section) => {
        document.getElementById(section).scrollIntoView({ behavior: "smooth" });
    };

    const [scrollTopVisible, setScrollTopVisible] = useState(false);

    useEffect(() => {
        new WOW.WOW({
            live: false,
        }).init();

        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, []);

    const checkScrollTop = () => {
        let scrollTopBtn = document.getElementById("back-to-top");

        if (scrollTopBtn) {
            if (
                document.body.scrollTop > 400 ||
                document.documentElement.scrollTop > 400
            ) {
                setScrollTopVisible(true);
            } else {
                setScrollTopVisible(false);
            }
        }
    };

    if (typeof window !== "undefined") {
        window.addEventListener("scroll", checkScrollTop);
    }

    return (<div className="relative">
        <div id="main-wrapper">
            <CourcesHeader
                textWhite={appliedIntro === introBackgroundConfig.image}
            ></CourcesHeader>

            <div id="content" role="main">
                <About/>
                <Author/>
                <Benefits/>
                <CallToAction/>
                <Program/>
                <Schedule/>
                <Payment/>
                {/*<Contact/>*/}
            </div>
            <Footer handleNavClick={handleNavClick}></Footer>
        </div>
        {/* back to top */}
        <Tooltip text="Back to Top" placement="left">
      <span
          id="back-to-top"
          className={ scrollTopVisible ? "display-inline rounded-circle" : "display-none rounded-circle" }
          // className="rounded-circle"
          // style={{ display: scrollTopVisible ? "inline" : "none" }}

          onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
          }}
      >
        <i className="fas fa-arrow-up"></i>
      </span>
        </Tooltip>
    </div>);
}

export default Courses;